import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { DefaultService } from "./default.service";
import * as firebase from "firebase/app";
import { AngularFireAuth } from "angularfire2/auth";

@Injectable()
export class MyGuard implements CanActivate{
    loggedIn = false;
    UserSesion;
    identity;
    
    //Compruebo que he iniciado sesion y sino, le llevo a login. Tambien sirve para no manipular la url
      constructor(public autorizacionService: DefaultService, public router: Router, public angularFireAuth: AngularFireAuth){
          
        this.autorizacionService.isLogged().subscribe(result => {
            if(result == null || result == undefined || result == ""){
                this.loggedIn = false;
                this.router.navigate(['home']);
                alert("Tienes que ser usuario premium para ver esta sección");
            }else{
                this.loggedIn = true;
            }
        });
      }

      canActivate(){
          return this.loggedIn;
      }
}


// WEBPACK FOOTER //
// ./src/services/my-guard.service.ts